import { Routes } from '@angular/router';
import {Accueil} from './components/accueil/accueil';
import {ChateauComponent} from './components/chateau-component/chateau-component';
import { ContactComponent } from './components/contact-component/contact-component';

export const routes: Routes = [
  { path: '', component: Accueil }, // Chemin par défaut
  { path: 'chateaux', component: ChateauComponent },
  { path: 'contact', component: ContactComponent },
  { path: '**', redirectTo: '' } // Redirige les erreurs 404 vers l'accueil
];
